export default class ImgSpirit {
  constructor(img, isStatic = false, reverse = false) {
    this.img = img
    this.angle = 0
    this.reverse = reverse
    this.isStatic = isStatic
  }
  update() {
    if (this.isStatic) {
      return
    }
    const maxAngle = this.reverse ? -360 : 360
    const offset = this.reverse ? -1 : 1
    this.angle = this.angle + offset
    
    if (this.angle > Math.abs(maxAngle)) {
      this.angle = 0
    }
  }
  draw(context, cx, cy) {
    // 绘制外部圆圈
    context.save()
    context.translate(cx, cy)
    context.rotate(Math.PI / 180 * this.angle)
    context.drawImage(this.img, -this.img.width / 2, -this.img.height / 2)
    context.restore()
  }
}

